import React, { useEffect, useRef } from 'react';
import Shared from '../../Components/Frame/Shared';
import * as rsuite from 'rsuite';
import { Table } from 'rsuite';
import { useState } from 'react';
import UserProp from '../../Components/User/UserProp';

import * as General from '../../General/General';
import axios from 'axios';
import { FaUser } from "react-icons/fa";
import {isMobile} from 'react-device-detect';
import Delete from '../../Components/Shared/Delete';
import * as Enum from '../../General/Enum';
import { useNavigate } from 'react-router-dom';
import ResponsiveList, { CardTitle, CardActions } from '../../Components/Shared/ResponsiveList';
import RowHeight from '../../Components/Shared/RowHeight';

const { Column, HeaderCell, Cell } = Table;



const Index = () => {

    //#region Const

    let navigate=useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [showDrawer, setShowDrawer] = useState(false);
    const [ShowLoader, setShowLoader] = useState(true);
    const [UserList, setUserList] = useState([]);
    const ref=useRef();
    const DeleteRef=useRef();
    const PopupRef=useRef();
    //#endregion


    
    
    //--> روی موبایل منوی Whisper اصلا رندر نمی شود، پس ref آن خالی است
    const ClosePopup = () => {
        if (PopupRef.current) {
            PopupRef.current.close();
        }
    }

    const ShowDelete = (Id) => {
        ClosePopup();
        DeleteRef.current.Show(Enum.DeleteType.User,Id);
    }
    const handleUserProp = (Id) => {
        if (isMobile) {
            setShowDrawer(true);
        } else {
            setShowModal(true);

        }
        setTimeout(() => {
                ref.current.ShowEdit(Id);
            }, 500);
            ClosePopup();
    };

    const BindUser = () => {
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/User/GetAll",
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
            },
             withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                if (res.data.length > 0) {
                    setUserList(res.data);
                }
                setShowLoader(false)
            })

            .catch(error=>{
                if (error.response)
                {
                    if (error.response.status===401)
                    {
                        navigate("/UnAuthorize")
                    }
                    else if (error.response.status===403)
                    {
                        navigate("/AccessDenied")
                    } 
                }
                else
                {
                    General.ShowMsg(Enum.MsgType.error,General.UnkownException(error));
                    setShowLoader(false);
                }
            })
    }

    useEffect(() => {
        BindUser();
    }, [])

    return (
        <Shared pageTitle={<><FaUser size={25} /> کاربران</>}>
            <div align="left">
                <rsuite.Button appearance="primary" className="mb-2" onClick={()=>handleUserProp(General.GuidEmpty())}>
                    ایجاد کاربر جدید
                </rsuite.Button>

            </div>
            <rsuite.Divider />
            <ResponsiveList
                fillHeight
                data={UserList}
                loading={ShowLoader}
                emptyText="کاربری ثبت نشده است"
                filters={[
                    { key: 'firstName', label: 'نام', type: 'text' },
                    { key: 'lastName', label: 'نام خانوادگی', type: 'text' }
                ]}
                renderCard={(rowData) => (
                    <>
                        <CardTitle>{rowData.firstName} {rowData.lastName}</CardTitle>
                        <CardActions>
                            <rsuite.Button size="sm" onClick={() => handleUserProp(rowData.id)}>
                                ویرایش
                            </rsuite.Button>
                            <rsuite.Button size="sm" appearance="primary" color="red" className='ms-2'
                                onClick={() => ShowDelete(rowData.id)}>
                                حذف
                            </rsuite.Button>
                        </CardActions>
                    </>
                )}
            >
                <Table
                    rtl={true}
                    className='w-100'
                    bordered
                    headerHeight={40}
                    rowHeight={RowHeight}
                    wordWrap="break-word"
                    data={UserList}
                    loading={ShowLoader}
                    onRowClick={(e) => console.dir(e)}

                >

                    <Column flexGrow={1}>
                        <HeaderCell ><b>ردیف</b></HeaderCell>
                        <General.RowNumber />
                    </Column>

                    <Column flexGrow={5} sortable>
                        <HeaderCell><b>نام</b></HeaderCell>
                        <Cell dataKey="firstName" />
                    </Column>
                    <Column flexGrow={5} sortable>
                        <HeaderCell><b>نام خانوادگی</b></HeaderCell>
                        <Cell dataKey="lastName" />
                    </Column>


                    <Column fixed="right" className='Popup'>
                        <HeaderCell>عملیات</HeaderCell>
                        <Cell >
                            {rowData => (
                                <rsuite.Whisper
                                    placement="bottomStart"
                                    controlId="control-id-with-dropdown"
                                    trigger="click"
                                    ref={PopupRef}
                                    speaker={
                                        <rsuite.Popover  full>
                                            <rsuite.Dropdown.Menu >
                                                <rsuite.Dropdown.Item onClick={() => handleUserProp(rowData.id)}>ویرایش</rsuite.Dropdown.Item>
                                                <rsuite.Dropdown.Item onClick={() => ShowDelete(rowData.id)}>حذف</rsuite.Dropdown.Item>
                                            </rsuite.Dropdown.Menu>
                                        </rsuite.Popover>
                                    }
                                >
                                    <rsuite.Button>...</rsuite.Button>
                                </rsuite.Whisper>
                            )}
                        </Cell>
                    </Column>
                </Table>
            </ResponsiveList>




            <rsuite.Modal open={showModal} onClose={() => setShowModal(false)} size="md">
                <rsuite.Modal.Header>
                    <rsuite.Modal.Title>مشخصات کاربر</rsuite.Modal.Title>
                </rsuite.Modal.Header>
                <rsuite.Modal.Body>
                    <UserProp ref={ref} onSubmit={() => (setShowModal(false), BindUser())} />
                </rsuite.Modal.Body>
            </rsuite.Modal>
            <rsuite.Drawer open={showDrawer} onClose={() => setShowDrawer(false)} placement="right" size="xs">
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title>مشخصات کاربر</rsuite.Drawer.Title>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <UserProp ref={ref} onSubmit={() => (setShowModal(false), BindUser())} />
                </rsuite.Drawer.Body>
            </rsuite.Drawer>
            <Delete ref={DeleteRef} onSubmit={BindUser}/>
        </Shared>
    );



}

export default Index;
